﻿const mapMarker = document.currentScript.dataset.mapMarker;
const latitude = parseFloat(document.currentScript.dataset.latitude);
const longitude = parseFloat(document.currentScript.dataset.longitude);

function initMap() {
	const coordinates = { lat: latitude, lng: longitude };

	const map = new google.maps.Map(document.getElementById("map"), {
		zoom: 10,
		center: coordinates
	});

	new google.maps.Marker({
		position: coordinates,
		icon: mapMarker,
		map
	});
}

window.initOfficeDetailMap = initMap;  